import React from 'react'
import { Link } from '@tanstack/react-router'
import { thaiRoute } from 'lib/dictionary-routes'
import { ThaiWordBasicProps } from 'core/interfaces/dictionary-thai-interfaces'
import { useTranslit } from 'hooks/useTranslit'
import ThaiWordListMeaning from './thai-word-list-meaning'
import CommonnessChip from '../../commonness-chip'
import { markSearchSource } from 'lib/analytics/events'

type Props = {
   word: ThaiWordBasicProps
}

const ThaiWordListItem = (props: Props) => {
   const { word } = props
   const translit = useTranslit().of(word.t2e)

   return (
      <li className="list-none">
         {/* The whole box is one anchor: a real href (so cmd/middle-click and
             "open in new tab" work) that TanStack intercepts for SPA nav. */}
         <Link
            {...thaiRoute(word.word)}
            className="flex items-center gap-[10px] p-[10px_12px] rounded-[12px] bg-white border border-hairline shadow-example cursor-pointer no-underline text-inherit transition-all duration-150 hover:-translate-y-[1px] hover:border-lightBlue hover:shadow-[0_4px_12px_rgba(20,30,50,0.09)]"
            onClick={() => markSearchSource('result_click')}
         >
            <div className="flex-1 min-w-0">
               <div className="flex flex-col items-start gap-[2px] [&_.thai]:text-bodyBlack [&_a]:text-[17px] [&_a]:font-semibold">
                  <span className="thai">{word.word}</span>
                  {translit && (
                     <div className="font-translit block m-0 text-[14px] italic text-translit">
                        {translit}
                     </div>
                  )}
               </div>
               <div className="pl-0 mt-[1px] text-[12.5px]">
                  {word.meanings.map((meaning, index) => (
                     <ThaiWordListMeaning
                        meaning={meaning}
                        key={index}
                        engTranslationWords={undefined}
                     />
                  ))}
               </div>
            </div>
            {word.commonnessScore != null && (
               <CommonnessChip commonnessScore={word.commonnessScore} display="meter" />
            )}
         </Link>
      </li>
   )
}

export default ThaiWordListItem
